import script from "./DropdownCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownCard.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownCard.vue?vue&type=style&index=0&id=762197fa&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-762197fa"]])

export default __exports__